import { connect } from 'react-redux'
import TextPanel from './TextPanel'
import { getText } from './text.actions'
import { saveTextViewedAudit, updateReviewGoal } from '../MediaPlayer/mediaPlayer.actions'
import { getHasReviewGoal } from '../MediaPlayer/mediaPlayer.selectors'

const mapStateToProps = ({
  media: {
    text: { text },
    main,
  },
}) => {
  return {
    data: text.data,
    hasReviewGoal: getHasReviewGoal(main),
  }
}

const mapDispatchToProps = dispatch => ({
  async requestText(contactId) {
    await dispatch(getText(contactId))
  },
  async auditTextViewed(contactId) {
    await dispatch(saveTextViewedAudit(contactId))
  },
  async completeReviewGoal(contactId, goalId, userId) {
    await dispatch(updateReviewGoal(contactId, goalId, { complete: true, personId: userId }))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(TextPanel)
